/* APEXX · Category carousel — assets/apexx-categories.js
   Arrow nav over a horizontal scroll-snap track. Multiple instances safe.
   Load with `defer`. Re-binds in the theme editor. */
(function () {
  function step(track) {
    // scroll by ~one viewport of cards (track width), minus a little so the
    // next card peeks in and orientation is preserved.
    return Math.max(track.clientWidth * 0.92, 240);
  }

  function updateArrows(section) {
    var track = section.querySelector('[data-cats-track]');
    var prev = section.querySelector('[data-cats-prev]');
    var next = section.querySelector('[data-cats-next]');
    if (!track) return;
    var max = track.scrollWidth - track.clientWidth - 2;
    var x = track.scrollLeft;
    var overflow = track.scrollWidth > track.clientWidth + 4;
    if (prev) prev.disabled = !overflow || x <= 2;
    if (next) next.disabled = !overflow || x >= max;
  }

  function bind(root) {
    (root || document).querySelectorAll('.apexx-cats').forEach(function (section) {
      if (section.dataset.catsBound) return;
      section.dataset.catsBound = '1';

      var track = section.querySelector('[data-cats-track]');
      var prev = section.querySelector('[data-cats-prev]');
      var next = section.querySelector('[data-cats-next]');
      if (!track) return;

      if (prev) prev.addEventListener('click', function () {
        track.scrollBy({ left: -step(track), behavior: 'smooth' });
      });
      if (next) next.addEventListener('click', function () {
        track.scrollBy({ left: step(track), behavior: 'smooth' });
      });

      track.addEventListener('scroll', function () {
        window.requestAnimationFrame(function () { updateArrows(section); });
      }, { passive: true });
      window.addEventListener('resize', function () { updateArrows(section); });

      updateArrows(section);
    });
  }

  document.addEventListener('DOMContentLoaded', function () { bind(document); });
  document.addEventListener('shopify:section:load', function (e) { bind(e.target); });
})();
